/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AllCommentsTabCommentContainer_story = {
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer1_story" | "CommentContainer_story">;
    readonly " $refType": "AllCommentsTabCommentContainer_story";
};
export type AllCommentsTabCommentContainer_story$data = AllCommentsTabCommentContainer_story;
export type AllCommentsTabCommentContainer_story$key = {
    readonly " $data"?: AllCommentsTabCommentContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabCommentContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllCommentsTabCommentContainer_story",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '7de4f60d82ab20c6925e1f77ab7c7bb1';
export default node;
